// src/components/CookieConsent.js
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import Modal from "react-modal";
import useDeviceType from "../hooks/useDeviceType";
import CookiesBouncing from "./CookiesBouncing";

// Estilo base para React Modal
Modal.setAppElement("#root");

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cookiePreferences, setCookiePreferences] = useState({
    essential: true, // Siempre activadas
    functional: false,
    analytics: false,
  });
  const isPortrait = useDeviceType();

  // Estilos para el modal
  const modalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      borderRadius: "10px",
      width: isPortrait ? '80vw' : '50vw',
      backgroundColor: "#f9f9f9",
    },
    overlay: {
      zIndex:123456,
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  };

  useEffect(() => {
    // Revisar si ya se aceptaron las cookies
    //const consent = localStorage.getItem("cookiesAccepted");
    const consent = Cookies.get("cookiesAccepted");
    if (!consent) setIsVisible(true);
  }, []);

  const handleAccept = () => {
    // Guardar aceptación en localStorage
    //localStorage.setItem("cookiesAccepted", "true");
    Cookies.set("cookiesAccepted", "true", { expires: 365 }); // Expira en 1 año
    Cookies.set("cookiePreferences", JSON.stringify(cookiePreferences), {
      expires: 365,
    }); // Guardar preferencias
    setIsVisible(false);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handlePreferenceChange = (category) => {
    setCookiePreferences((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  if (!isVisible) return null; // No mostrar si ya se aceptaron

  return (
    <>
      {isVisible && <CookiesBouncing />}
      {isVisible && (
        <div style={styles.container}>
          <p style={{fontSize:"2vw"}}>
            Utilizamos cookies para mejorar tu experiencia.{" "}
            <a href="/aviso_privacidad" style={styles.link}>
              Más información
            </a>.
          </p>
          <div style={styles.buttons}>
            <button onClick={handleAccept} style={styles.acceptButton}>
              Aceptar todas
            </button>
            <button onClick={toggleModal} style={styles.settingsButton}>
              Configurar
            </button>
          </div>
        </div>
      )}

      {/* Modal de Configuración */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        style={modalStyles}
        contentLabel="Configuración de Cookies"
      >
        <h2>Configuración de Cookies</h2>
        <p>Selecciona las cookies que deseas habilitar:</p>
        <div style={styles.preferences}>
          <label>
            <input
              type="checkbox"
              checked={cookiePreferences.essential}
              disabled
            />
            Esenciales (requeridas)
          </label>
          <label>
            <input
              type="checkbox"
              checked={cookiePreferences.functional}
              onChange={() => handlePreferenceChange("functional")}
            />
            Funcionales
          </label>
          <label>
            <input
              type="checkbox"
              checked={cookiePreferences.analytics}
              onChange={() => handlePreferenceChange("analytics")}
            />
            Analíticas
          </label>
        </div>
        <div style={styles.modalButtons}>
          <button onClick={handleAccept} style={styles.acceptButton}>
            Guardar
          </button>
          <button onClick={toggleModal} style={styles.settingsButton}>
            Cancelar
          </button>
        </div>
      </Modal>
    </>
  );

};

// Estilos en línea
const styles = {
  container: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#666",
    color: "#fff",
    padding: "10px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "5vh",
    zIndex: 100000,
  },
  link: {
    color: "#61dafb",
    textDecoration: "underline",
  },
  buttons: {
    display: "flex",
    gap: "10px",
  },
  acceptButton: {
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  settingsButton: {
    backgroundColor: "#f1c40f",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  preferences: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "20px",
  },
  modalButtons: {
    marginTop: "20px",
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
  },
};

export default CookieConsent;
